var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 26,
  viewBox: "0 0 26 26"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-835 -561)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(835 561)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 26,
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.751 2.991)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.705,19.981a2.56,2.56,0,0,1-2.572-2.541,2.53,2.53,0,0,1,.516-1.528H10.612A2.56,2.56,0,1,1,5.986,17.44,2.53,2.53,0,0,1,6.5,15.911H4.928a.883.883,0,0,1-.79-.48.859.859,0,0,1,.076-.911L6.089,11.5,4.632,4.527,4.04,1.749H.885A.881.881,0,0,1,0,.874.88.88,0,0,1,.885,0H4.757a.887.887,0,0,1,.867.693l.135.63L21.6,1.374a.881.881,0,0,1,.666.31.852.852,0,0,1,.189.7L20.73,11.926a.868.868,0,0,1-.858.709l-12.451.022-.75,1.508H21.6a.873.873,0,1,1,0,1.746H18.76a2.536,2.536,0,0,1-2.055,4.07Zm0-3.324a.783.783,0,1,0,.792.783A.788.788,0,0,0,16.705,16.657Zm-8.148,0a.783.783,0,1,0,.792.783A.788.788,0,0,0,8.557,16.657ZM6.128,3.046h0L7.81,10.935l11.336-.019L20.56,3.094,6.128,3.046Z",
  transform: "translate(0 0)",
  fill: "#ff7a45"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M0,0H15.364l-.709,8.7H1.673Z",
  transform: "translate(842.091 566.909)",
  fill: "#ff7a45"
}))));
export default __webpack_public_path__ + "static/media/processing-snapshot.4d3a1714.svg";
export { SvgComponent as ReactComponent };